// tslint:disable:max-line-length
import { Injectable } from '@angular/core';

import { USER_AGENTS } from './user-agents';

@Injectable()
export class UtilService {
  isOnline: boolean;
  origin: string =  window.location.origin;

  constructor() {
    //console.log('****');
    this.getDeviceType2();
  }

  getDeviceType(): 'desktop' | 'mobile' {
    let isMobile = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      ) {
        isMobile = true;
      }
    })(navigator.userAgent || navigator.vendor);

    if (isMobile) {
      return 'mobile';
    } else {
      return 'desktop';
    }
  }

  getDeviceType2(): 'desktop' | 'tablet' | 'mobile' {
    //console.log(USER_AGENTS.getCurrentDevice());
    return USER_AGENTS.getCurrentDevice();
  }

  setNativeNetworkStatus(isNwAvailable) {
    this.isOnline = isNwAvailable;
  }

  getNativeNetworkStatus() {
    return this.isOnline;
  }

  /**
   * Returns information about how app is being accessed
   * @returns web - for browser based access, iOS - iOS native app access, Android - Android native app access
   */
  getNativeOS() {
    let nativeOS: 'iOS' | 'Android' | 'web' = 'web';

    if (navigator.userAgent.indexOf('AndroidPortalApp') > -1) {
      nativeOS = 'Android';
    } else if (navigator.userAgent.indexOf('iOSPortalApp') > -1) {
      nativeOS = 'iOS';
    }

    return nativeOS;
  }

  /**
   * Detects IE browser
   */
  isIEBrowser() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');

    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

  /**
   * Scrolls to an element on the page using a CSS selector.
   * @param selector the selector of an element to scroll to. Can be any type of CSS selector
   * such as #profile, .profile, etc.
   */
  scrollTo(selector: string) {
    const elem: any = document.querySelector(selector);
    const top = elem.offsetTop - 80;

    // if elem exits scroll to it
    if (elem) {
      window.scrollTo({
        top,
        behavior: 'smooth'
      });

      // now we need to focus the element so that keyboard only users will not face
      // issue when they continue to navigate with there keyboard.
      // SEE: https://css-tricks.com/smooth-scrolling-accessibility/
      elem.setAttribute('tabindex', '-1');
      elem.focus();

      // if the elem does not exist we will throw a
      // meaningful error
    } else {
      console.error('ScrollToService: Element with selector ' + selector + ' not found!');
    }
  }

  getEnvName() {
    // CF MyAccount app can have the following first parts
    // Added 'idp-' item to support Interops login screen by Okta idp url
    const domainFirstParts = ['m', 'member', 'idp-'];

    // First part is followed by one of the following environments.
    // leaving the other properties incase we need them in future
    const domainSecondParts = {
      'dev': {
        'env': 'dev',
        'pegasystemID': 'ecomdeva',
        'releasetype': 'dev',
      },
      'dev2': {
        'env': 'dev2',
        'pegasystemID': 'ecomdeva',
        'releasetype': 'dev',
      },
      'sita': {
        'env': 'sita',
        'pegasystemID': 'ecomdeva',
        'releasetype': 'sit',
      },
      'sitb': {
        'env': 'sitb',
        'pegasystemID': 'ecomdeva',
        'releasetype': 'sit',
      },
      'tt': {
        'env': 'tt',
        'pegasystemID': 'ecomdeva',
        'releasetype': 'sit',
      },
      'prodsupport': {
        'env': 'prodsupport',
        'pegasystemID': 'ecomdeva',
        'releasetype': 'sit',
      },
      'uat': {
        'env': 'uat',
        'pegasystemID': 'ecomdeva',
        'releasetype': 'sit',
      }
    };


    for (let i = 0; i < domainFirstParts.length; i++) {
      for (const domainSecondPart in domainSecondParts) {
        if (domainSecondParts.hasOwnProperty(domainSecondPart)) {
          const domain = domainFirstParts[i] + domainSecondPart;
          const urlPart = this.origin.split('/')[2];
          const originTest = urlPart.split('.');
          const firstPart = originTest[0];

          if(firstPart === 'idp-sita') {
            return domainSecondParts.tt.env;
          } else if (firstPart === domain) {
            const data = domainSecondParts[domainSecondPart];
            return data.env;
          }
        }
      }
    }

    return 'prod';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/util.service.ts